import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import CUIcon from '@/components/CUIcon.vue'
import { ReservationDetail } from '@/models/dto';
import { DateTime } from 'luxon'
import { currencyFilter } from '@/utils/string';


export default /*#__PURE__*/_defineComponent({
  __name: 'MakeBankPayment',
  props: {
    reservation: null
  },
  setup(__props: any) {

const props = __props as {
  reservation: ReservationDetail
};



const copiedField = ref('')
let timeoutId: ReturnType<typeof setTimeout> | null = null

const copy = async (text: string, label: string) => {
  await navigator.clipboard.writeText(text)
  copiedField.value = label
  if (timeoutId) clearTimeout(timeoutId)
  timeoutId = setTimeout(() => {
    copiedField.value = ''
  }, 2000)
}

const formattedAmount = computed(() => {
  return currencyFilter(props.reservation.balance);
});

const formattedDueDate = computed(() => {
  return DateTime.fromISO(props.reservation.dueDate)
    .toLocaleString({
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    })
})


return { __sfc: true,props, copiedField, timeoutId, copy, formattedAmount, formattedDueDate, CUIcon }
}

})